import React, { useEffect, useState } from "react";
import "./viewUsers.css";
import SearchBar from "../Main/searchBar";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { Link, useParams } from "react-router-dom";
import { ReactComponent as Email } from "../../Global Icons/Email.svg";
import { ReactComponent as Name } from "../../Global Icons/Name.svg";
import { ReactComponent as Num } from "../../Global Icons/Phone Number.svg";
import { ReactComponent as Status } from "../../Global Icons/Status.svg";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { columnsUserBookings, columnsPayments } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
import { Table } from "antd";
import { getBookingsList } from "../../Redux/Actions/usersActions";
import { listPayments } from "../../Redux/Actions/paymentsActions";
import { getUser } from "../../Redux/Actions/usersActions";
import { ToFirstCapital, formatBytes } from "../../Utils/helpers";

const ViewUsers = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [foundUser, setFoundUser] = useState({});
  const [selectedTable, setSelectedTable] = useState("post_bookings");
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canEdit = Array.isArray(accessCode) && accessCode.includes("edit");

  const { id } = useParams();
  const dispatch = useDispatch();
  const [userSpec, setUserSpec] = useState(null);
  const [showSpecModal, setShowSpecModal] = useState(false);

  const { singleUser } = useSelector((state) => state.users || {});
  const { userBookings } = useSelector((state) => state.users || {});
  const { payments } = useSelector((state) => state.payments || {});
  console.log("userbookings",userBookings)

  useEffect(() => {
    if (foundUser?.user_specification) {
      try {
        setUserSpec(JSON.parse(foundUser.user_specification));
      } catch (error) {
        setUserSpec(null);
      }
    }
  }, [foundUser]);

  useEffect(() => {
    dispatch(getUser(id));
  }, [id, dispatch]);

  useEffect(() => {
    setFoundUser(singleUser?.data);
  }, [singleUser, id]);

  useEffect(() => {
    const bookingsPayload = {
      page: 1,
      limit: 500,
      is_deleted: false,
      user_id: id,
    };

    if (selectedTable === "post_bookings") {
      dispatch(getBookingsList(bookingsPayload));
    } else if (selectedTable === "payments") {
      dispatch(listPayments(bookingsPayload));
    }
  }, [id, dispatch, selectedTable]);

  const changeStatusHandler = async (event) => {
    const status = event.target.value;
    try {
      const response = await axios.post(
        `${BASE_URL}/user/change-status`,
        { id, status },
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.status === 200) {
        toast.success("Successfully changed!");
        dispatch(getUser(id));
      }
    } catch (error) {
      toast.error("Error changing status");
    }
  };

  const isBlocked = foundUser?.status === "block";

  return (
    <div className="vu-page">
      <div className="vu-topbar">
        <div className="vu-header">
          <Link to="/manage_users" className="vu-back-link">
            <BackIcon />
          </Link>
          <div>
            <h3 className="vu-title">{ToFirstCapital(foundUser?.name)}</h3>
            <p className="vu-breadcrumb">Users / List / View</p>
          </div>
        </div>

        <div className="vu-searchbar">
          <SearchBar style={{ width: "max-content" }} />
        </div>
      </div>

      <div className="vu-layout">
        {/* Profile */}
        <div className="vu-profile-card">
          <div className="vu-profile-header">
            <div className="vu-avatar-wrap">
              <img
                className="vu-avatar"
                alt="profile"
                src={
                  foundUser?.profile_image
                    ? foundUser.profile_image
                    : require("../../Global Icons/AlternateImage.png")
                }
              />
              <span className={`vu-status-pill ${isBlocked ? "is-blocked" : "is-active"}`}>
                {isBlocked ? "Blocked" : "Active"}
              </span>
            </div>

            <div className="vu-profile-actions">
              <button
                onClick={changeStatusHandler}
                disabled={!canEdit}
                className="vu-btn vu-btn-block"
                value="block"
              >
                Block user
              </button>
              <button
                onClick={changeStatusHandler}
                disabled={!canEdit}
                className="vu-btn vu-btn-unblock"
                value="unblock"
              >
                Unblock user
              </button>
            </div>
          </div>

          <div className="vu-info-list">
            <div className="vu-info-row">
              <span className="vu-info-label">User ID</span>
              <span className="vu-info-value">{foundUser?.user_id || "N/A"}</span>
            </div>

            <div className="vu-info-row">
              <span className="vu-info-icon"><Name /></span>
              <span className="vu-info-label">Full name</span>
              <span className="vu-info-value">{foundUser?.name || "No data"}</span>
            </div>

            <div className="vu-info-row">
              <span className="vu-info-icon"><Email /></span>
              <span className="vu-info-label">Email</span>
              <span className="vu-info-value">{foundUser?.email || "No data"}</span>
            </div>

            <div className="vu-info-row">
              <span className="vu-info-icon"><Num /></span>
              <span className="vu-info-label">Phone number</span>
              <span className="vu-info-value">{foundUser?.contact_number || "No data"}</span>
            </div>

            <div className="vu-info-row">
              <span className="vu-info-icon"><Status /></span>
              <span className="vu-info-label">Account status</span>
              <span className="vu-info-value">{isBlocked ? "Blocked" : "Un-blocked"}</span>
            </div>
          </div>

          {userSpec && (
            <div className="vu-spec-card">
              <div className="vu-spec-header">
                <span className="vu-spec-title">User specifications</span>
                {Object.keys(userSpec).length > 2 && (
                  <button className="vu-view-all-btn" onClick={() => setShowSpecModal(true)}>
                    View all ({Object.keys(userSpec).length})
                  </button>
                )}
              </div>

              <div className="vu-spec-list">
                {Object.entries(userSpec)
                  .slice(0, 2)
                  .map(([key, value]) => {
                    const stringValue = String(value);
                    const isBytesField = ["storage", "freestorage", "ram"].includes(key.toLowerCase());
                    const displayValue = isBytesField && !isNaN(value)
                      ? formatBytes(Number(value))
                      : stringValue.length > 50
                        ? `${stringValue.substring(0, 50)}...`
                        : stringValue;

                    return (
                      <div key={key} className="vu-spec-item">
                        <span className="vu-spec-key">
                          {key.length > 20 ? `${key.substring(0, 20)}...` : key}
                        </span>
                        <span
                          className="vu-spec-value"
                          title={isBytesField ? `${stringValue} (${formatBytes(Number(value))})` : stringValue}
                        >
                          {displayValue}
                        </span>
                      </div>
                    );
                  })}
              </div>
            </div>
          )}
        </div>

        {/* Data tables */}
        <div className="vu-data-section">
          <div className="vu-tabs">
            <button
              className={`vu-tab ${selectedTable === "post_bookings" ? "is-active" : ""}`}
              onClick={() => setSelectedTable("post_bookings")}
            >
              Post bookings
            </button>
            <button
              className={`vu-tab ${selectedTable === "payments" ? "is-active" : ""}`}
              onClick={() => setSelectedTable("payments")}
            >
              Payments
            </button>
          </div>

          <div className="vu-table-wrap">
            {selectedTable === "post_bookings" && (
              <Table
                columns={columnsUserBookings}
                dataSource={Array.isArray(userBookings?.data) ? userBookings.data : []}
                pagination={{ pageSize: 10 }}
                scroll={{ x: "max-content" }}
              />
            )}

            {selectedTable === "payments" && (
              <Table
                columns={columnsPayments}
                dataSource={Array.isArray(payments?.data) ? payments.data : []}
                pagination={{ pageSize: 10 }}
                scroll={{ x: "max-content" }}
              />
            )}
          </div>
        </div>
      </div>

      {showSpecModal && userSpec && (
        <div className="vu-modal-overlay" onClick={() => setShowSpecModal(false)}>
          <div className="vu-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="vu-modal-header">
              <h3>User specifications ({Object.keys(userSpec).length})</h3>
              <button className="vu-modal-close-btn" onClick={() => setShowSpecModal(false)}>
                ×
              </button>
            </div>
            <div className="vu-modal-list">
              {Object.entries(userSpec).map(([key, value]) => {
                const stringValue = String(value);
                const isBytesField = ["storage", "freestorage", "ram"].includes(key.toLowerCase());
                const displayValue = isBytesField && !isNaN(value)
                  ? formatBytes(Number(value))
                  : stringValue;

                return (
                  <div key={key} className="vu-modal-item">
                    <span className="vu-modal-key">{key}</span>
                    <span className="vu-modal-value" title={stringValue}>
                      {displayValue}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewUsers;